import React, { Fragment } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';

export const renderDisplayName = (params: GridRenderCellParams<any, any, any>) => {
  const row: any = params.row;

  const toTitleCase = (str: string) => {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
      }
    );
  }

  return <Fragment>{toTitleCase(row.lastName)}, {toTitleCase(row.firstName)}</Fragment>;
};
